// frontend/src/components/EstateEditorNew.jsx
import React, { useState } from "react";
import BuildingInfoOverlay from "./BuildingInfoOverlay";

/**
 * 신규등록 전용 에디터
 * - pnu 필수
 * - 기존 EstateEditor와 완전 분리
 */
export default function EstateEditorNew({
  open,
  estate,          // 신규등록용 estate (pnu 필수)
  onClose,
  onSaved,
}) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [buildingInfo, setBuildingInfo] = useState(null);
    const [buildingOpen, setBuildingOpen] = useState(false);
    const [buildingSelectedHo, setBuildingSelectedHo] = useState("");
    const [draft, setDraft] = useState({
    estate_dong: "",
    estate_ho: "",
    floor: "",
    exclusive_area_m2: "",
    exclusive_area_py: "",
    });
  // 🔒 방어: pnu 없으면 렌더 자체를 막음


  if (!open) return null;

  if (!estate?.pnu) {
    return (
      <div style={overlayStyle}>
        <div style={panelStyle}>
          <h3>신규등록 오류</h3>
          <p style={{ color: "#c00" }}>
            PNU가 없는 상태에서는 신규등록을 진행할 수 없습니다.
          </p>
            <button
            onClick={handleSave}
            disabled={loading}
            style={{
                marginRight: 8,
                padding: "6px 14px",
                background: "#2b6cb0",
                color: "#fff",
                border: "none",
                borderRadius: 6,
                cursor: "pointer",
            }}
            >
            신규등록 저장
            </button>
          <button onClick={onClose}>닫기</button>
        </div>
      </div>
    );
  }

    const handleSave = async () => {
    if (!estate?.pnu) {
        setError("PNU가 없습니다.");
        return;
    }

    try {
        setLoading(true);
        setError("");

        const payload = {
        pnu: estate.pnu,
        roadAddress: estate.roadAddress,
        jibunAddress: estate.jibunAddress,

        estate_dong: draft.estate_dong,
        estate_ho: draft.estate_ho,
        floor: draft.floor,

        exclusive_area_m2: draft.exclusive_area_m2,
        exclusive_area_py: draft.exclusive_area_py,
        };

        const res = await fetch("/api/properties/new-by-pnu", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
        });

        const data = await res.json();

        if (!res.ok || !data.ok) {
        throw new Error(data.error || "신규등록 실패");
        }

        if (typeof onSaved === "function") {
        onSaved(data);
        }

        onClose();
    } catch (e) {
        setError(e.message);
    } finally {
        setLoading(false);
    }
    };

  return (
    <div style={overlayStyle}>
      <div style={panelStyle}>
        <h3>신규 매물 등록</h3>

        {/* 🔑 핵심 정보 */}
        <div style={{ marginBottom: 12 }}>
          <div><strong>PNU</strong>: {estate.pnu}</div>
          <div><strong>도로명</strong>: {estate.roadAddress || "-"}</div>
          <div><strong>지번</strong>: {estate.jibunAddress || "-"}</div>
        </div>

        {/* TODO: 여기부터 신규등록 전용 UI 추가 */}
        <div style={{ fontSize: 13, color: "#666" }}>
          ※ 이 에디터는 신규등록 전용입니다.
        </div>

        <div style={{ marginTop: 12 }}>
        <button 
            onClick={() => {
                setBuildingSelectedHo("");
                setBuildingOpen(true);
                handleFetchBuildingInfo();
            }}
        >
            건물정보 확인
        </button>

            {draft.estate_ho && (
            <div
                style={{
                marginTop: 12,
                padding: 10,
                background: "#eef6ff",
                borderRadius: 6,
                fontSize: 12,
                }}
            >
                <div><strong>동</strong>: {draft.estate_dong}</div>
                <div><strong>호</strong>: {draft.estate_ho}</div>
                <div><strong>층</strong>: {draft.floor}</div>
                <div>
                <strong>전용면적</strong>:
                {draft.exclusive_area_m2} ㎡ (
                {draft.exclusive_area_py} 평)
                </div>
            </div>
            )}


        </div>

            <BuildingInfoOverlay
            open={buildingOpen}
            onClose={() => setBuildingOpen(false)}
            loading={loading}
            error={error}
            buildingInfo={buildingInfo}
            onApply={(payload) => {
            /*
                payload 예시:
                {
                dong: "101동",
                ho: "1002호",
                floor: 10,
                exclusiveAreaM2: 84.97,
                exclusiveAreaPy: 25.7
                }
            */

            setDraft((prev) => ({
                ...prev,
                estate_dong: payload.dong ?? "",
                estate_ho: payload.ho ?? "",
                floor: payload.floor ?? "",
                exclusive_area_m2: payload.exclusiveAreaM2 ?? "",
                exclusive_area_py: payload.exclusiveAreaPy ?? "",
            }));

            setBuildingOpen(false);
            }}

            selectedHo={buildingSelectedHo}
            onChangeHo={setBuildingSelectedHo}
            estateHo={estate?.estate_ho}
            pnu={estate?.pnu}
            />

        <div style={{ marginTop: 16 }}>
          <button onClick={onClose}>닫기</button>
        </div>
            {loading && (
            <div style={{ marginTop: 8, fontSize: 12 }}>조회 중...</div>
            )}

            {error && (
            <div style={{ marginTop: 8, color: "#c00", fontSize: 12 }}>
                {error}
            </div>
            )}

            {buildingInfo && (
            <div
                style={{
                marginTop: 12,
                padding: 10,
                background: "#f8f8f8",
                borderRadius: 6,
                fontSize: 12,
                }}
            >
                <div><strong>건물명</strong>: {buildingInfo.bldNm || "-"}</div>
                <div><strong>주용도</strong>: {buildingInfo.mainPurpsCdNm || "-"}</div>
                <div><strong>사용승인일</strong>: {buildingInfo.useAprDay || "-"}</div>
                <div><strong>연면적</strong>: {buildingInfo.totArea || "-"}</div>
            </div>
            )}
      </div>
    </div>
  );
}

/* ====== 단순 오버레이 스타일 (임시) ====== */

const overlayStyle = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.4)",
  zIndex: 5000,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const panelStyle = {
  background: "#fff",
  borderRadius: 8,
  padding: 20,
  width: 480,
  maxWidth: "90vw",
};
